module.exports = __webpack_public_path__ + "img/ANTENNA FLOWER BW.a5c3385.svg";